import {Routes} from "@angular/router";
import {WorkflowCspOneDowngradeSlaComponent} from "./workflow-csp-one-downgrade-sla.component";

export const workflowCspOneDowngradeSlaRouting: Routes = [
    { path: 'csp/downgrade-sla/:aid', component: WorkflowCspOneDowngradeSlaComponent, children: [
            { path: 'info', component: WorkflowCspOneDowngradeSlaComponent },
            { path: 'address', component: WorkflowCspOneDowngradeSlaComponent },
            { path: 'payment', component: WorkflowCspOneDowngradeSlaComponent },
            { path: 'checkout', component: WorkflowCspOneDowngradeSlaComponent },
            { path: 'complete', component: WorkflowCspOneDowngradeSlaComponent },
            { path: '', redirectTo: 'info', pathMatch: 'full' },
    ]},
]
